(function () {
  if (window.ucCartAddonAnchorLoaded) return;
  window.ucCartAddonAnchorLoaded = true;

  var drawerSelector = '#halo-cart-sidebar';
  var wrapperSelector = drawerSelector + ' .previewCart-wrapper';
  var frame = null;
  var addonPanelOpen = true;
  var styleId = 'uc-cart-addon-anchor-style';

  function injectStyle() {
    if (document.getElementById(styleId)) return;
    var style = document.createElement('style');
    style.id = styleId;
    style.textContent = [
      '#halo-cart-sidebar.uc-cart-redo .uc-cart-shell{display:flex;flex-direction:column;}',
      '#halo-cart-sidebar.uc-cart-redo .uc-cart-lines{order:1;}',
      '#halo-cart-sidebar.uc-cart-redo .uc-cart-nudge{order:2;}',
      '#halo-cart-sidebar.uc-cart-redo .uc-cart-addon-panel{order:3;}',
      '#halo-cart-sidebar.uc-cart-redo .uc-cart-footer{order:4;}',
      '#halo-cart-sidebar.uc-cart-redo .uc-cart-shell>.uc-cart-addons{visibility:hidden!important;height:0!important;margin:0!important;padding:0!important;overflow:hidden!important;}',
      '#halo-cart-sidebar.uc-cart-redo .uc-cart-addon-panel>.uc-cart-addons{visibility:visible!important;height:auto!important;overflow:visible!important;}',
      '#halo-cart-sidebar .uc-cart-trust{display:none!important;}'
    ].join('');
    document.head.appendChild(style);
  }

  function addonSummaryMarkup() {
    return '<div><strong>Complete Your Setup</strong><span>Optional add-ons</span></div>';
  }

  function rememberToggle(panel) {
    if (!panel || panel.dataset.ucAddonAnchorToggle === 'true') return;
    panel.dataset.ucAddonAnchorToggle = 'true';
    panel.addEventListener('toggle', function () {
      addonPanelOpen = panel.open;
    });
  }

  function ensureSummary(panel) {
    var summary = panel.querySelector(':scope > .uc-cart-addon-summary');
    if (summary) return summary;
    summary = document.createElement('summary');
    summary.className = 'uc-cart-addon-summary';
    summary.innerHTML = addonSummaryMarkup();
    panel.insertBefore(summary, panel.firstChild);
    return summary;
  }

  function ensurePanel(shell, addons) {
    var panel = addons.closest('.uc-cart-addon-panel') || shell.querySelector('.uc-cart-addon-panel');
    if (!panel) {
      panel = document.createElement('details');
      panel.className = 'uc-cart-addon-panel';
      if (addons.parentNode) addons.parentNode.insertBefore(panel, addons);
      panel.appendChild(addons);
    } else if (addons.parentNode !== panel) {
      panel.appendChild(addons);
    }
    ensureSummary(panel);
    rememberToggle(panel);
    if (addonPanelOpen) panel.setAttribute('open', '');
    else panel.removeAttribute('open');
    return panel;
  }

  function anchorAddons() {
    var drawer = document.querySelector(drawerSelector);
    var wrapper = document.querySelector(wrapperSelector);
    if (!drawer || !wrapper) return;
    var shell = wrapper.querySelector('.uc-cart-shell');
    if (!shell) return;

    var lines = shell.querySelector('.uc-cart-lines');
    var nudge = shell.querySelector('.uc-cart-nudge');
    var addons = shell.querySelector('.uc-cart-addons');
    var footer = shell.querySelector('.uc-cart-footer');
    if (!addons) return;

    var panel = ensurePanel(shell, addons);
    if (lines && shell.firstElementChild !== lines) shell.insertBefore(lines, shell.firstElementChild);
    if (nudge && lines && nudge.previousElementSibling !== lines) shell.insertBefore(nudge, lines.nextSibling);
    if (footer) {
      if (panel.parentNode !== shell || panel.nextElementSibling !== footer) shell.insertBefore(panel, footer);
    } else if (panel.parentNode !== shell || shell.lastElementChild !== panel) {
      shell.appendChild(panel);
    }
    drawer.classList.add('uc-cart-addon-anchored');
  }

  function scheduleAnchor() {
    if (frame) return;
    frame = window.requestAnimationFrame(function () {
      frame = null;
      anchorAddons();
      window.setTimeout(anchorAddons, 40);
    });
  }

  function openDrawerFallback() {
    document.body.classList.add('cart-sidebar-show');
    var drawer = document.querySelector(drawerSelector);
    if (drawer) drawer.setAttribute('aria-hidden', 'false');
  }

  function requestCustomCart(open) {
    var opened = false;
    if (typeof window.openCartDrawer === 'function') {
      window.openCartDrawer();
      opened = true;
    } else if (typeof window.openSliderCart === 'function') {
      window.openSliderCart();
      opened = true;
    } else if (typeof window.refreshCartDrawer === 'function') {
      window.refreshCartDrawer();
    }
    if (open && !opened) openDrawerFallback();
    scheduleAnchor();
    window.setTimeout(scheduleAnchor, 80);
    window.setTimeout(scheduleAnchor, 350);
  }

  function isCartTrigger(target) {
    if (!target || !target.closest) return null;
    return target.closest('a[href$="/cart"], a[href="/cart"], a[href*="/cart?"], [data-open-cart-sidebar], [data-cart-sidebar], [data-cart-drawer], [data-cart-toggle], [data-cart-trigger], .header__icon--cart, .cart-icon, .cart-count-bubble, .site-header__cart, .header-cart');
  }

  function handleCartTrigger(event) {
    var trigger = isCartTrigger(event.target);
    if (!trigger || trigger.closest(drawerSelector)) return;
    event.preventDefault();
    event.stopPropagation();
    if (typeof event.stopImmediatePropagation === 'function') event.stopImmediatePropagation();
    requestCustomCart(true);
  }

  function watchPossibleAdd(event) {
    if (!event.target || !event.target.closest || event.target.closest(drawerSelector)) return;
    var trigger = event.target.closest('form[action*="/cart/add"], button[name="add"], [type="submit"][name="add"], .product-form__submit, [data-add-to-cart]');
    if (!trigger) return;
    window.setTimeout(function () { requestCustomCart(false); }, 250);
    window.setTimeout(function () { requestCustomCart(false); }, 900);
  }

  function bind() {
    injectStyle();
    scheduleAnchor();
    ['uc:cart:updated', 'uc:cart:open', 'uc:cart:refresh', 'cart-update', 'cart:updated', 'cart:refresh', 'ajaxCart:updated'].forEach(function (name) {
      document.addEventListener(name, scheduleAnchor);
    });
    window.addEventListener('click', handleCartTrigger, true);
    document.addEventListener('click', handleCartTrigger, true);
    document.documentElement.addEventListener('click', handleCartTrigger, true);
    document.addEventListener('click', watchPossibleAdd, true);
    document.addEventListener('submit', watchPossibleAdd, true);
    var wrapper = document.querySelector(wrapperSelector);
    if (wrapper && window.MutationObserver) {
      new MutationObserver(scheduleAnchor).observe(wrapper, { childList: true, subtree: true });
    }
    var drawer = document.querySelector(drawerSelector);
    if (drawer && window.MutationObserver) {
      new MutationObserver(scheduleAnchor).observe(drawer, { childList: true, subtree: true, attributes: true, attributeFilter: ['class', 'aria-hidden'] });
    }
    window.setTimeout(scheduleAnchor, 300);
    window.setTimeout(scheduleAnchor, 1200);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', bind);
  else bind();
})();
